"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _propTypes = require("prop-types");

var _form = require("@widergy/web-utils/lib/form");

var _UTLabel = _interopRequireDefault(require("../UTLabel"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UTCuit = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTCuit, _PureComponent);

  function UTCuit() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTCuit);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTCuit)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      prefix: '',
      verificationCode: '',
      document: '',
      verificationCodeRef: null,
      documentRef: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeCuit", function () {
      var _this$state = _this.state,
          prefix = _this$state.prefix,
          document = _this$state.document,
          verificationCode = _this$state.verificationCode;

      _this.props.input.onChange(prefix.concat(document, verificationCode));
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      var regexp = /[0-9]+/g;

      if (!regexp.test(event.key)) {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChangePrefix", function (event) {
      var normalizePrefix = event.target.value.replace(/^[^2-3]/g, '');
      var prefix = normalizePrefix.slice(0, 2);

      _this.setState({
        prefix: prefix
      }, _this.handleChangeCuit);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChangeDocument", function (event) {
      var document = event.target.value.slice(0, 8);

      _this.setState({
        document: document
      }, _this.handleChangeCuit);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChangeVerificationCode", function (event) {
      var verificationCode = event.target.value.slice(0, 1);

      _this.setState({
        verificationCode: verificationCode
      }, _this.handleChangeCuit);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetDocument", function (value) {
      _this.setState({
        document: value.padStart(8, '0')
      });
    });

    _defineProperty(_assertThisInitialized(_this), "verificationCodeRef", function (input) {
      _this.setState({
        verificationCodeRef: input
      });
    });

    _defineProperty(_assertThisInitialized(_this), "documentRef", function (input) {
      _this.setState({
        documentRef: input
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      if (_this.state.prefix.length === 2 && _this.state.document.length === 8) {
        _this.state.verificationCodeRef.focus();
      } else if (_this.state.prefix.length === 2) {
        _this.state.documentRef.focus();
      }
    });

    return _this;
  }

  _createClass(UTCuit, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.prefix.length === 0 && this.state.document.length === 0 && this.state.verificationCode.length === 0 && this.props.input && this.props.input.value && this.props.field.configuration.disable_document) this.handleSetDocument(this.props.input.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          prefix = _this$state2.prefix,
          document = _this$state2.document,
          verificationCode = _this$state2.verificationCode;
      this.handleFocus();
      return _react["default"].createElement("div", {
        className: _stylesModule["default"].container
      }, _react["default"].createElement("div", {
        className: _stylesModule["default"].fieldContainer
      }, _react["default"].createElement(_TextField["default"], {
        className: _stylesModule["default"].fieldCuit,
        name: "prefix",
        label: this.props.field.label,
        autoComplete: "off",
        placeholder: "XX",
        InputLabelProps: {
          shrink: this.props.input.value !== 0
        },
        onChange: this.handleOnChangePrefix,
        onKeyPress: this.handleKeyPress,
        error: (0, _form.shouldShowErrors)(this.props.meta) ? this.props.meta.error : '',
        value: prefix,
        InputProps: "input",
        fullWidth: true,
        margin: "none",
        autoFocus: this.props.field.configuration.auto_focus
      }), _react["default"].createElement(_TextField["default"], {
        name: "document",
        className: _stylesModule["default"].fieldDocument,
        autoComplete: "off",
        placeholder: "XXXXXXXX",
        onKeyPress: this.handleKeyPress,
        disabled: this.props.field.configuration.disable_document,
        error: (0, _form.shouldShowErrors)(this.props.meta) ? this.props.meta.error : '',
        value: document,
        onChange: this.handleOnChangeDocument,
        fullWidth: true,
        InputProps: "text",
        margin: "none",
        inputRef: this.documentRef
      }), _react["default"].createElement(_TextField["default"], {
        autoComplete: "off",
        className: _stylesModule["default"].fieldCuit,
        name: "verificationCode",
        placeholder: "X",
        fullWidth: true,
        onKeyPress: this.handleKeyPress,
        error: (0, _form.shouldShowErrors)(this.props.meta) ? this.props.meta.error : '',
        onChange: this.handleOnChangeVerificationCode,
        value: verificationCode,
        InputProps: "input",
        margin: "none",
        inputRef: this.verificationCodeRef
      })), _react["default"].createElement(_UTLabel["default"], {
        small: true,
        error: true
      }, (0, _form.shouldShowErrors)(this.props.meta) ? this.props.meta.error : ''));
    }
  }]);

  return UTCuit;
}(_react.PureComponent);

UTCuit.propTypes = {
  input: (0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    onBlur: _propTypes.func.isRequired,
    onChange: _propTypes.func.isRequired,
    onFocus: _propTypes.func.isRequired,
    value: _propTypes.any.isRequired
  }),
  meta: (0, _propTypes.shape)({
    error: _propTypes.string
  }),
  field: _propTypes.any // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _WithTheme["default"])(null, _theme.retrieveMuiTheme)(UTCuit);

exports["default"] = _default;